"use client";

import CommonEdit from "@/components/common/Edit";
import { FC, useEffect, useState } from "react";
import DriverForm from "./DriverForm";
import { singleProp } from "@/interface/dataInterface";
import axios from "axios";
import { BASE_URL } from "@/config";
import vehicle from "@/garageManagment/vehicle";
import axiosInstance from "@/utils/axiosInstance";
import { Driver } from "@/interface/entityInterface";

const DriverEdit: FC<singleProp> = ({ prop }) => {
  const [formProp, setFormProp] = useState({
    firstname: "",
    lastname: "",
    phone: "",
    vehicle_id: 0,
    status: "",
    email: "",
    driver_license: "",
    can_complete_order: 'no',
  });

  useEffect(() => {
    if (!prop) return;
    const unsub = async () => {
      const { data } = await axiosInstance.get<Driver>(`/drivers/${prop}`);

      const {
        user,
        vehicle_id,
        status,
        phone,
        driver_license,
        can_complete_order,
      } = data;
      const { firstname, lastname, email } = user;
      setFormProp({
        firstname,
        lastname,
        phone,
        vehicle_id,
        status,
        email,
        driver_license: driver_license || "",
        can_complete_order: can_complete_order ? "yes" : "no",
      });
    };

    unsub();
  }, [prop]);

  return (
    <CommonEdit
      id={prop}
      title="Edit"
      resource="drivers"
      data={{
        driver: {
          name: formProp.firstname + " " + formProp.lastname,
          vehicle_id: formProp.vehicle_id,
          phone: formProp.phone,
          status: formProp.status || "OFFLINE",
          driver_license: formProp.driver_license || null,
          can_complete_order: formProp.can_complete_order === "yes" ? true : false
        },
        user: {
          firstname: formProp.firstname,
          lastname: formProp.lastname,
          email: formProp.email,
        },
      }}
      responseMessage="Driver updated"
    >
      <DriverForm mode="edit" formProp={formProp} setFormProp={setFormProp} />
    </CommonEdit>
  );
};

export default DriverEdit;
